var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5072 15.8961C34.5904 16.1878 35.4446 17.0419 35.7362 18.1252C36.2778 20.1042 36.257 24.229 36.257 24.229C36.257 24.229 36.257 28.3329 35.7362 30.312C35.4446 31.3952 34.5904 32.2494 33.5072 32.541C31.5281 33.0618 23.6119 33.0618 23.6119 33.0618C23.6119 33.0618 15.7165 33.0618 13.7166 32.5202C12.6334 32.2285 11.7793 31.3744 11.4876 30.2911C10.9668 28.3329 10.9668 24.2082 10.9668 24.2082C10.9668 24.2082 10.9668 20.1042 11.4876 18.1252C11.7793 17.0419 12.6542 16.1669 13.7166 15.8753C15.6957 15.3545 23.6119 15.3545 23.6119 15.3545C23.6119 15.3545 31.5281 15.3545 33.5072 15.8961ZM27.6742 24.2082L21.0913 27.9997V20.4168L27.6742 24.2082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.0d6c9e4de5270942ffe1c9047b7661c2.svg";
export { ForwardRef as ReactComponent };